"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
var react_helmet_1 = require("react-helmet");
Object.defineProperty(exports, "Head", { enumerable: true, get: function () { return react_helmet_1.Helmet; } });
//# sourceMappingURL=Head.js.map